import React from "react";
import { observer } from "mobx-react";
import BreadCrumbComponent from "Components/common/breadcrumb";
import { KnowMoreButton } from "Components/common/KnowMoreButton";
import userDetail from "Stores/userDetail";
import inboxV2Store from "./InboxV2/inboxV2Store";

export const HeaderSection = observer(() => {
  const breadcrumbArr = [{ name: "Inbox", link: "/inbox" }];
  // Once a contact is open in Inbox V2 the page is a conversation view; reflect that in
  // the breadcrumb, and let "Inbox" take the user back.
  const inConversation =
    userDetail?.userFeatureFlag?.inboxV2Enabled &&
    !!inboxV2Store?.selectedContact;

  return (
    <section className="headerSection">
      <div className="breadCrumbWrapper">
        {inConversation ? (
          <div className="breadCrumbcont">
            <div className="breadCrumbInnerCont">
              <span className="seperator" />
              <button
                type="button"
                className="breadValue inboxV2CrumbBack"
                onClick={() => inboxV2Store.clearSelection()}
              >
                Inbox
              </button>
            </div>
            <div className="breadCrumbInnerCont">
              <span className="seperator">/</span>
              <span className="breadValue text-path">Replies</span>
            </div>
          </div>
        ) : (
          <BreadCrumbComponent breadCrumbValue={breadcrumbArr} />
        )}
      </div>
      <div className="headerBtnContainer">
        <KnowMoreButton
          redirectUrl={
            "https://support.salesgear.io/en/collections/3174605-outbox"
          }
        />
      </div>
    </section>
  );
});

export default HeaderSection;
